export default {
	closure: {
		color: 'rgba(255, 255, 255, 0.12)'
	}
};
